import('../src/javascripts/attachments-redesign');
import('../src/javascripts/navigation');
import('../src/javascripts/easy-toggle');

document.addEventListener('DOMContentLoaded', () => {
  const questions = document.querySelectorAll('.Question');
  const answerItems = document.querySelectorAll('.AnswersBar--item');
  const totalQuestions = questions.length;
  const state = getState();

  setAnswerHandlers(answerItems, state, totalQuestions);
  updateProgressBar(totalQuestions, state.question);

  processNextButton(totalQuestions);
  processPrevButton(state.question);
  processAnswersSelect()
  showCurrentQuestion(state.question);
});

function showCurrentQuestion(question) {
  const currentQuestion = document.querySelector(`.Question[data-question="${question}"]`);
  if (!currentQuestion) {
    return
  }

  currentQuestion.classList.add('isActive');
}

function buildURL(state) {
  const params = {...state, answers: state.answers.join(',')};
  const newParams = new URLSearchParams(params);
  const location = window.location.href;
  const url = new URL(location);

  url.search = newParams.toString();
  return url;
}

function parseQueryString(url) {
  const queryString = new URL(url).search;
  const params = new URLSearchParams(queryString);
  const parsedParams = {};

  for (const [key, value] of params.entries()) {
    parsedParams[key] = value;
  }
  return parsedParams;
}

function getState() {
  const params = parseQueryString(window.location.href);
  const question = parseInt(params.question, 10) || 1;
  const answers = params.answers ? params.answers.split(',') : [];

  return {
    question: question,
    answers: answers,
  }
}

function noop(e) {
  e.preventDefault();
}

function updateProgressBar(totalQuestions, question) {
  const progressBar = document.querySelector('.ProgressBar');
  if (!progressBar) {
    return
  }
  const currentQuestionSpan = document.querySelector('.js-current-question');
  const progressPercentageSpan = document.querySelector('.js-progress-percentage');
  const percentage = Math.round((question / totalQuestions) * 100);

  progressBar.setAttribute("style", `--bar-width: ${percentage}%`);
  progressPercentageSpan.textContent = `${percentage}%`;
  currentQuestionSpan.textContent = question;
}

function setAnswerHandlers(answerItems, state, totalQuestions) {
  answerItems.forEach(item => {
    item.addEventListener('change', e => {
      const value = e.target.value;
      const answers = [...state.answers];
      answers[state.question - 1] = value
      const url = buildURL({...state, answers});

      history.pushState(null, "", url);
      processNextButton(totalQuestions);
    });
  });
}

function processNextButton(totalQuestions) {
  const nextButton = document.querySelector('.Button--next');
  if (!nextButton) {
    return
  }
  const {answers, question} = getState();
  const answersParams = answers.join(',');
  const newParams = new URLSearchParams({answers: answersParams});
  const url = new URL(`/questionnaire/submitAnswer`, window.location);

  url.search = newParams.toString();

  const clickHandler = e => {
    e.preventDefault();
    const state = getState();
    const newState = {...state, question: state.question + 1};
    const url = buildURL(newState);
    window.location = url;
  }

  if (question === totalQuestions) {
    nextButton.textContent = 'Know my score!';
  }

  if (question === totalQuestions && answers[question - 1]) {
    nextButton.removeEventListener('click', noop);
    nextButton.href = url;
  }

  if (!answers[question - 1] && question <= totalQuestions) {
    nextButton.classList.add('isDisabled');
    nextButton.removeEventListener('click', clickHandler);
    nextButton.addEventListener('click', noop);
    return;
  }

  nextButton.classList.remove('isDisabled');
  nextButton.removeEventListener('click', noop);

  if (question < totalQuestions) {
    nextButton.addEventListener('click', clickHandler);
  }
}

function processPrevButton(question) {
  const prevButton = document.querySelector('.Button--prev');

  if (!prevButton) {
    return
  }

  if (question === 1) {
    prevButton.style.display = 'none';
    return;
  }

  prevButton.addEventListener('click', e => {
    e.preventDefault();
    const state = getState();
    const newState = {...state, question: state.question - 1};
    const url = buildURL(newState);
    window.location = url;
  });
}

function processAnswersSelect() {
  const {question, answers} = getState();
  const index = question - 1;
  const answerIndex = answers[index];
  const answer = document.querySelector(`input[value="${answerIndex}"]`);

  if (answer) {
    answer.checked = true;
  }
}
